import { HttpErrorResponse, HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { EMPTY, Observable, of, throwError } from 'rxjs';
import { catchError, switchMap, tap } from 'rxjs/operators';
import { RootUrls, Delivery, Logs, Assessment } from '../app.urls';
import { CollectionService } from './collection.service';
@Injectable()
export class GlobalInterceptor implements HttpInterceptor {
  subdomain: string;
  accessTokenFromStorage: any;
  skipHeader: Array<string> = [Logs.logError];
  lang: string;
  constructor(private router: Router, private collectionServ: CollectionService) { }

  intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    this.getSubdomain();
    let currentUserFromStorage: any;

    if (request.url.includes(Delivery.InterceptorUrl) || request.url.includes(Delivery.consent)) {
      currentUserFromStorage = JSON.parse(sessionStorage.examineeUser || '{}');
      this.accessTokenFromStorage = currentUserFromStorage.accessToken;
    }
    else {
      currentUserFromStorage = JSON.parse(sessionStorage.currentUser || '{}');
      this.accessTokenFromStorage = currentUserFromStorage.accessToken;
    }

    if (this.router.url.includes(`/delivery/start/test`) || this.router.url.includes('/td/') || this.router.url.includes('/delivery/consentForm')) {
      const isTestLangAvailable = localStorage.getItem('test-language');
      isTestLangAvailable ? this.lang = isTestLangAvailable : this.lang = 'en-US'
    } else {
      const isHomeLangAvailable = localStorage.getItem('language');
      isHomeLangAvailable ? this.lang = isHomeLangAvailable : this.lang = 'en-US'
    }

    if (!request.url.indexOf(RootUrls.AIApi)) {
      let req = request.clone();
      if (sessionStorage.aiToken) { req = request.clone({ setHeaders: { 'Authorization': `Bearer ${JSON.parse(sessionStorage.aiToken)}` } }); }
      return next.handle(req).pipe(catchError(x => this.handleAuthError(x)));
    } else if (this.skipHeader.includes(request.url)) {
      return next.handle(request).pipe(catchError(x => this.handleAuthError(x)));
    } else {
      let req = request.clone({
        setHeaders: {
          subDomainName: this.subdomain, TimezoneOffset: this.getTimezoneOffset(),
          'Authorization': `Bearer ${this.accessTokenFromStorage}`,
          'X-Content-Type-Options': 'nosniff',
          'X-Frame-Options': 'SAMEORIGIN',
          'X-XSS-Protection': '1; mode=block',
          'Cache-Control': 'no-cache, no-store, must-revalidate',
          'Strict-Transport-Security': 'max-age=31536000; includeSubDomains',
          'Referrer-Policy': 'no-referrer',
          'Accept-Language': this.lang,
          // 'Accept-Language': 'en-US',
        }
      });
      return next.handle(req).pipe(catchError(x => this.handleAuthError(x, req, next)));
    }
  }

  private handleAuthError(err: HttpErrorResponse, req?, next?): Observable<any> {
    if (err.status === 403) {
      if (sessionStorage.currentUser) { sessionStorage.removeItem('currentUser'); }
      this.router.navigate(['/login'], {});
      return of(err.message);
    }
    else if(err.status === 401 && req.url.indexOf('refresh-token') === -1){
      return this.collectionServ.getNewAccessToken().pipe(
        switchMap((res: any) => {

        // Update tokens in storage
        const currentUser = JSON.parse(sessionStorage.currentUser);
        currentUser.accessToken = res.accessToken;
        currentUser.refreshToken = res.refreshToken;
        sessionStorage.setItem('currentUser', JSON.stringify(currentUser));

          // Clone the failed request with the new token
          const clonedRequest = req.clone({
            setHeaders: {
              'Authorization': `Bearer ${res.accessToken}`
            }
          });

          // Retry the failed request
          return next.handle(clonedRequest);
        }),
        catchError((refreshError) => {
          console.log('refreshError')
          // If refresh token fails, navigate to login
          // this.router.navigate(['/login']);
          return throwError(refreshError);
        })
      )
    }
    else if (err.status === 401 && req.url.indexOf('refresh-token') > 0){
      sessionStorage.clear();
      this.router.navigate(['/login'], {});
    }
    return throwError(err);
  }



  getSubdomain() {
    const domain = window.location.hostname;
    if (
      domain.indexOf('.') < 0 ||
      domain.split('.')[0] === 'example' ||
      domain.split('.')[0] === 'lvh' ||
      domain.split('.')[0] === 'www'
    ) {
      this.subdomain = 'drr';
      // this.subdomain = 'tanay';
    } else {
      // this.subdomain = 'drr';
      this.subdomain = domain.split('.')[0];
      // this.subdomain = 'diydemo';
    }
    return this.subdomain;
  }

  getTimezoneOffset(): string {
    return (String(new Date().getTimezoneOffset()))
  }
}
